import React, { useState } from 'react';
import { ExternalLink, Menu, X } from 'lucide-react';
import { useLocation } from 'react-router-dom';

const Navbar: React.FC = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 px-6 py-4 sm:py-8 bg-charcoal/80 backdrop-blur-md">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2 sm:gap-3 group">
          <div className="w-14 h-14 sm:w-20 sm:h-20 flex items-center justify-center">
            <img src="/tabla-logo-v2.png" alt="Riyaz Tools Logo" className="w-full h-full object-contain" />
          </div>
          <div className="flex flex-col justify-center">
            <span className="text-lg sm:text-xl font-semibold text-white tracking-wide leading-none mb-1">Riyaz Tools</span>
            <span className="text-[10px] sm:text-xs font-mono text-neutral-500 tracking-widest uppercase">by Manmit Singh</span>
          </div>
        </a>

        {/* Nav Links */}
        <div className="hidden sm:flex items-center gap-8">
          <a href={isHome ? "#apps" : "/#apps"} className="text-base font-medium text-neutral-400 hover:text-gold transition-colors duration-200">
            Apps
          </a>
          <a href={isHome ? "#about" : "/#about"} className="text-base font-medium text-neutral-400 hover:text-gold transition-colors duration-200">
            About
          </a>
          <a
            href="https://manmitsinghmusic.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-base font-medium text-neutral-400 hover:text-gold transition-colors duration-200"
          >
            Main Site
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        {/* Mobile menu button */}
        <button 
          className="sm:hidden p-2 text-neutral-400 hover:text-gold transition-colors z-50"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="sm:hidden absolute top-full left-0 right-0 bg-charcoal/95 backdrop-blur-xl border-b border-white/[0.06] p-6 flex flex-col gap-6 shadow-2xl">
          <a href={isHome ? "#apps" : "/#apps"} onClick={() => setIsMobileMenuOpen(false)} className="text-lg font-medium text-neutral-300 hover:text-gold transition-colors duration-200">
            Apps
          </a>
          <a href={isHome ? "#about" : "/#about"} onClick={() => setIsMobileMenuOpen(false)} className="text-lg font-medium text-neutral-300 hover:text-gold transition-colors duration-200">
            About
          </a>
          <a
            href="https://manmitsinghmusic.com"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setIsMobileMenuOpen(false)}
            className="inline-flex items-center gap-2 text-lg font-medium text-neutral-300 hover:text-gold transition-colors duration-200"
          >
            Main Site
            <ExternalLink className="w-5 h-5" />
          </a>
        </div>
      )}

      {/* Frosted bottom border */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" />
    </nav>
  );
};

export default Navbar;
